export default __webpack_public_path__ + "static/media/mestari2.779914fd.png";